import { useMemo, useState } from 'react';
import { EmptyState } from '@astryxdesign/core/EmptyState';
import { ArrowUpRightIcon, MagnifyingGlassIcon } from '@phosphor-icons/react';
import { PillButton } from '@/components/kit';
import { ClientHeader } from '@/features/studio/ClientHeader';
import { useDocumentTitle } from '@/lib/hooks';
import { useStudio } from '@/features/studio/studio-data';
import { useBookingNav } from '@/features/booking/useBookingNav';
import { groupServices, ServiceRow } from '@/features/booking/steps/ServiceStep';

export function ServicesPage() {
  const studio = useStudio();
  const booking = useBookingNav();
  const [query, setQuery] = useState('');
  useDocumentTitle(`Услуги и цены — ${studio.name}`);

  const groups = useMemo(() => {
    const q = query.trim().toLowerCase();
    const services = q
      ? studio.services.filter((s) => `${s.name} ${s.category} ${s.description}`.toLowerCase().includes(q))
      : studio.services;
    return groupServices(services);
  }, [studio.services, query]);

  return (
    <div className="ui-page">
      <ClientHeader />
      <div className="ui-stack" style={{ ['--ui-gap' as string]: '6px' }}>
        <h1 className="ui-h1">Услуги и цены</h1>
        <p className="ui-muted">Цена «от» уточняется после осмотра автомобиля.</p>
      </div>

      {studio.services.length > 6 ? (
        <label className="ui-field" style={{ position: 'relative' }}>
          <span className="visually-hidden">Поиск услуги</span>
          <MagnifyingGlassIcon
            size={18}
            aria-hidden
            style={{ position: 'absolute', left: 16, top: 16, color: 'var(--color-text-secondary)' }}
          />
          <input
            className="ui-input"
            style={{ paddingLeft: 44 }}
            type="search"
            placeholder="Найти услугу"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </label>
      ) : null}

      {groups.length === 0 ? (
        <EmptyState title="Ничего не нашлось" description="Попробуйте другое слово или спросите в студии." isCompact />
      ) : (
        groups.map(([category, services]) => (
          <section
            key={category}
            className="ui-stack"
            style={{ ['--ui-gap' as string]: 'var(--spacing-3)' }}
            aria-label={category}
          >
            <h2 className="ui-h2">{category}</h2>
            <div className="ui-list">
              {services.map((service) => (
                <ServiceRow
                  key={service.id}
                  service={service}
                  currency={studio.currency}
                  action="Записаться"
                  description={service.description || undefined}
                  onSelect={() => booking.open(service.id)}
                />
              ))}
            </div>
          </section>
        ))
      )}
      <PillButton variant="primary" size="lg" block endIcon={ArrowUpRightIcon} onClick={() => booking.open()}>
        Записаться
      </PillButton>
    </div>
  );
}
